import {styled} from '@mui/material';
import {Link} from '@mui/material';

const Component = styled(Link)<any>(props => ({
  color: props.theme.palette.secondary.main,
  opacity: 0.7,
  transition: 'all ease 0.3s',
  textDecoration: 'none',
  fontSize: props.theme.typography.pxToRem(14),
  wordBreak: 'break-all',
  padding: props.theme.spacing(0, 1.5),
  ':hover': {
    color: props.theme.palette.primary.main,
    opacity: 1,
    textDecoration: 'underline',
  },
}));

export default Component;
